let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("16ic3")).then(() => parcelRequire('52A0r'));